import { request } from './utils/http';

const noop = _ => _;

export default class CommonUploadPlugin {
  constructor(options) {
    this.settings = { ...options
    };
  }

  install(ctx) {
    const self = this;
    const {
      settings
    } = self;
    const {
      beforeUpload = noop,
      afterUpload = noop
    } = settings; // 自定义上传功能

    ctx.plugin('upload-file', async (vm, file, cb) => {
      const {
        uploadUrl,
        uploadParams = {},
        uploadHeaders = {},
        fileName = 'file'
      } = settings;
      const requestConfig = {
        url: uploadUrl,
        body: { ...uploadParams,
          [fileName]: file
        },
        headers: { ...uploadHeaders,
          'Content-Type': uploadHeaders.contentType || 'multipart/form-data'
        }
      };

      try {
        const res = await request(beforeUpload(requestConfig));
        cb(afterUpload(res));
      } catch (e) {
        console.error(e.message);
        cb(null);
      }
    });
  }

}